export const PETITE_PROFILE_SET_ACTIVE = 'PETITE_PROFILE_SET_ACTIVE';
